module.exports = __webpack_public_path__ + "static/media/dog-german-shepherd.8bdabccc.png";